<template>
    <p class="finance__terms">
        *<template v-if="personalQuote">This is your personal quote, we will retain your deposit as you move around the website. </template>
        Quotes are valid for a maximum of 14 days from {{ quoteValidFrom }} and may be withdrawn without notice. Finance subject to status and age limitations. {{ financeName }}. 18s+. Guarantee may be required. <b>Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a credit broker and not a lender.</b>
        <template v-if="hasDsg">
            We may introduce you to a carefully selected group of finance providers.
        </template>
        <a class="finance-calculator__terms-link" href="/terms-and-conditions#used-car-online-sale-terms-and-conditions-161" target="_blank">Ts and Cs Apply</a>

        <template v-if="selectedValuation">
            <br>^ This is an estimated valuation of your vehicle based on the information you have provided. It is not an offer to purchase your vehicle. The estimated valuation may change and the condition of your vehicle will be inspected by the purchaser. You should ensure that you have taken into account any other costs connected with the disposal of your current vehicle before committing to a deposit for any new vehicle under a finance agreement.
        </template>
    </p>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        financeTypes: {
            type: Array,
            required: false,
        },
        financeType: {
            required: true,
        },
        quoteValidFrom: {
            type: String,
            required: true,
        }
    },
    computed: {
        ...mapState("FinanceParameters", {
            personalQuote: "modified",
        }),
        ...mapState("Valuations", ["selectedValuation"]),
        financeName() {
            if (this.financeType == 'HP') {
                return 'Conditional Sale';
            }
            return 'Personal Contract Purchase';
        },
        hasDsg() {
            if (this.financeType == 'DSG_PCP_ONLY') {
                return true;
            }
            if (!this.financeTypes) {
                return false;
            }
            const financeTypesLength = this.financeTypes.length;
            if (financeTypesLength == 0) {
                return false;
            }
            for (let index = 0; index < financeTypesLength; index++) {
                if (this.financeTypes[index] == 'DSG_PCP_ONLY') {
                    return true;
                }
            }
            return false;
        }
    }
}
</script>

<style>

</style>